import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-carousel",
  imports: [],
  templateUrl: "./icon-carousel.component.html",
  styleUrl: "./icon-carousel.component.scss",
})
export class IconCarouselComponent {
  @Input() color = "#000";
}
